import { applicationApi } from "../../common/api";
import { GetTransactionListRequest, Transaction, TransactionAccount, TransactionReport } from "./types";

// Define a service using a base URL and expected endpoints
export const transactionApi = applicationApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllTransaction: builder.query<Transaction[], GetTransactionListRequest>({
      query: (params) => ({
        url: "/transaction",
        method: "GET",
        params: params,
      }),
      providesTags: [{ type: "MemoTransaction", id: "LIST" }],
    }),
    getTransaction: builder.query<Transaction, string>({
      query: (query) => `/transaction/id/${query}`,
    }),
    createTransaction: builder.mutation<Transaction, any>({
      query: (body) => ({
        url: "/transaction",
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "MemoTransaction", id: "LIST" }],
    }),
    deleteTransaction: builder.mutation<any, number>({
      query: (id) => ({
        url: `/transaction/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "MemoTransaction", id: "LIST" }],
    }),
    updateTransaction: builder.mutation<Transaction, any>({
      query: (body) => ({
        url: `/transaction`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: [{ type: "MemoTransaction", id: "LIST" }],
    }),
    validateTransaction: builder.mutation<any, any>({
      query: (body) => ({
        url: `/transaction/validate/${body}`,
        method: "PATCH",
      }),
      invalidatesTags: [{ type: "MemoTransaction", id: "LIST" }],
    }),
    finalizeTransaction: builder.mutation<any, any>({
      query: (body) => ({
        url: `/transaction/finalize`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: [{ type: "MemoTransaction", id: "LIST" }],
    }),
    transactionReport: builder.query<TransactionReport, any>({
      query: (body) => ({
        url: `/transaction/report`,
        method: "GET",
        params: body,
      }),
    }),
    getAllTransactionAccount: builder.query<TransactionAccount[], void>({
      query: (query) => `/transaction/account`,
      providesTags: [{ type: "MemoTransactionAccount", id: "LIST" }],
    }),
    getTransactionAccount: builder.query<TransactionAccount, string>({
      query: (query) => `/transaction/account/${query}`,
    }),
    createTransactionAccount: builder.mutation<TransactionAccount, any>({
      query: (body) => ({
        url: "/transaction/account",
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "MemoTransactionAccount", id: "LIST" }],
    }),
    deleteTransactionAccount: builder.mutation<any, number>({
      query: (id) => ({
        url: `/transaction/account/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "MemoTransactionAccount", id: "LIST" }],
    }),
    updateTransactionAccount: builder.mutation<TransactionAccount, any>({
      query: (body) => ({
        url: `/transaction/account/${body.id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: [{ type: "MemoTransactionAccount", id: "LIST" }],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAllTransactionQuery,
  useGetTransactionQuery,
  useCreateTransactionMutation,
  useDeleteTransactionMutation,
  useUpdateTransactionMutation,
  useValidateTransactionMutation,
  useFinalizeTransactionMutation,
  useTransactionReportQuery,

  useCreateTransactionAccountMutation,
  useGetAllTransactionAccountQuery,
  useGetTransactionAccountQuery,
  useDeleteTransactionAccountMutation,
  useUpdateTransactionAccountMutation,
} = transactionApi;
